/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { AssessmentScores } from '../../api/materiality-assessment';
import Table, { TableColumn } from '../../../../components/table/Table';

interface AssessmentScoreRow {
  materialityCode: string; // @TODO - when codes are definted, should use that instead of string
  score: number;
}

interface AssessmentResultsProps {
  scores: AssessmentScores;
}

export const AssessmentResults = (props: AssessmentResultsProps) => {
  const { scores } = props;

  function convertScoresToRows(scores: AssessmentScores): AssessmentScoreRow[] {
    const rows: AssessmentScoreRow[] = [];
    Object.keys(scores).forEach(scoreKey => {
      rows.push({
        materialityCode: scoreKey,
        score: scores[scoreKey]
      });
    });
    return rows;
  }

  const scoresTableColumns: TableColumn<AssessmentScoreRow>[] = [
    {
      Header: 'Materiality',
      accessor: 'materialityCode'
    },
    {
      Header: 'Score',
      accessor: 'score',
      cellProps: {
        className: 'text-right'
      }
    }
  ];

  return <Table<AssessmentScoreRow> data={convertScoresToRows(scores)} columns={scoresTableColumns} />
}
